module.exports = __webpack_public_path__ + "static/img/ic-qrcode.60cf6fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-qrcode.png
// module id = 645
// module chunks = 17